export default __webpack_public_path__ + "static/media/sponsor-6.7e965df4.svg";